/* istanbul ignore file */

export const classNames = {
	// root container
	rootContainerView: 'gc_root_container_view',
	rootHeaderView: 'gc_header_view',
	rootBodyView: 'gc_body_view',
	rootScrollbarView: 'gc_scrollbar_view',

	// tree
	treeView: 'gc_tree_view',
	treeHeaderView: 'gc_tree_header_view',
	treeHeaderRow: 'gc_tree_header_row',
	treeHeaderCell: 'gc_tree_header_cell',
	treeTableView: 'gc_tree_table_view',
	treeTableRow: 'gc_tree_table_row',
	treeTableCell: 'gc_tree_table_cell',
	treeScrollbarView: 'gc_tree_scrollbar_cell',

	// timeline
	timelineView: 'gc_timeline_view',
	timelineHeaderView: 'gc_timeline_header_view',
	timelineHeaderGapView: 'gc_timeline_header_gap_view',
	timelineHeaderRow: 'gc_timeline_header_row',
	timelineHeaderCell: 'gc_timeline_header_cell',
	timelineTableView: 'gc_timeline_table_view',
	timelineTableGridView: 'gc_timeline_table_grid_view',
	timelineTableTaskView: 'gc_timeline_table_task_view',
	timelineTableLinkView: 'gc_timeline_table_link_view',
	timelineTableRow: 'gc_timeline_table_row',
	timelineTableCell: 'gc_timeline_table_cell',
	timelineTableTask: 'gc_timeline_table_task',
	timelineScrollbarView: 'gc_timeline_scrollbar_cell',
	timelineScrollbarGapView: 'gc_timeline_scrollbar_gap',

	// generic classes
	borderTop: 'gc_border_top',
	borderBottom: 'gc_border_bottom',
	borderLeft: 'gc_border_left',
	borderRight: 'gc_border_right',
	borderRightWide: 'gc_border_right_wide',
};
